import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createGalleryGalleryItem: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    isAddModalVisible: false,
    fields: new (Record({
      name: "",
      description: "",
      mediaUID: ""
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/galleries/forms.js